import routes from "./end-points";

export const captchaApi = {
    imageUrl: routes.captcha.imageUrl,
};
